export default "__VITE_ASSET__BqBbnEgs__"